module.exports = __webpack_public_path__ + "img/ps.41a1c54e.svg";